import { CpuChipIcon } from '@heroicons/react/24/outline';
import type { ServerStatus } from '../services/backend';

const PIPELINE_BADGE: Record<ServerStatus['extraction']['types'][number]['pipeline'], string> = {
  agentic: 'bg-indigo-50 text-indigo-700 dark:bg-indigo-900/50 dark:text-indigo-300',
  single: 'bg-amber-50 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
};

export function ServerStatusExtraction({ extraction }: { extraction: ServerStatus['extraction'] }) {
  return (
    <div className="rounded-lg border border-gray-100 bg-white p-6 shadow-sm dark:border-zinc-700 dark:bg-zinc-800 dark:text-zinc-100">
      <div className="mb-1 flex items-center gap-2">
        <CpuChipIcon className="h-5 w-5 text-indigo-600 dark:text-indigo-400" />
        <h3 className="text-lg font-medium text-gray-900 dark:text-zinc-100">Data extraction</h3>
      </div>
      <p className="mb-4 text-xs text-gray-500 dark:text-zinc-500">Per-category pipeline and model.</p>
      <dl className="space-y-3">
        {extraction.types.map((type) => (
          <div
            key={type.category}
            className="flex flex-col gap-0.5 sm:flex-row sm:items-center sm:justify-between"
          >
            <dt className="text-sm font-medium text-gray-500 dark:text-zinc-400">{type.category}</dt>
            <dd className="flex items-center gap-2 sm:justify-end">
              <span
                className={`rounded px-1.5 py-0.5 text-[11px] font-medium ${PIPELINE_BADGE[type.pipeline]}`}
              >
                {type.pipeline}
              </span>
              <span className="break-all font-mono text-xs text-gray-900 dark:text-zinc-100">{type.model}</span>
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
